import React, { useEffect, useState, useRef } from 'react'
import { observer } from 'mobx-react';
import { useStore } from '../../../stores';
import './style.scss';
import { TextInput, OutlinedButton } from '../../../components';
const UserIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/people.png`
const Credipple = `${process.env.REACT_APP_CDN_URL}/globalAssets/CredippleLogo.svg`;
const AddIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/AddIcon.svg`;
const DeleteIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/DeleteIcon.svg`;
const EditIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/EditIcon.svg`;
var mobile = require('is-mobile');

const Profile = observer(() => {
    const { authStore, userStore, uiStore } = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [IsEditDetails, setIsEditDetails] = useState(false);
    const [IsEditPassword, setIsEditPassword] = useState(false);
    const [FullName, setFullName] = useState('');
    const [User, setUser] = useState({});
    const [Password, setPassword] = useState('');
    const [ConfirmPassword, setConfirmPassword] = useState('')
    const EmailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    useEffect(() => {
        getUser();
    }, []);
    const getUser = () => {
        setUser({ ...authStore.user });
        const fullName = `${authStore.user.firstName} ${authStore.user.lastName}`;
        setFullName(fullName);
        forceUpdate();
    };
    const handleEditPassword = () => {
        setIsEditDetails(true);
        setIsEditPassword(true);
        forceUpdate();
    };
    const handleEditPasswordClose = () => {
        setIsEditDetails(false);
        setIsEditPassword(false);
        forceUpdate();
    };
    const handleUserInfoChange = (e) => {
        let user = User;
        if (e.currentTarget.id === 'FullName') {
            let fullName = e.target.value;
            user.firstName = fullName.split(' ')[0];
            user.lastName = fullName.split(' ')[1];
            setFullName(fullName);
        }
        if (e.currentTarget.id === 'Email') {
            user.email = e.target.value;
        }
        if (e.currentTarget.id === 'Phone') {
            user.phone = e.target.value;
        }
        setUser(user);
        forceUpdate();
    };
    const handleUpdateUserClicked = async () => {
        let user = User;
        let userEmail = authStore.user.email;
        let regexPass = EmailRegex.test(user.email);
        uiStore.setLoading(true);
        if (!regexPass) {
            uiStore.showNotification('Invalid email address.', 'error');
            uiStore.setLoading(false);
            return;
        } else {
            let updateUser = await userStore.updateUserByEmail(user, userEmail)
            if (updateUser !== 'error') {
                authStore.user = updateUser
                setUser(updateUser);
                setIsEditDetails(false);
                setIsEditPassword(false);
                uiStore.showNotification('Profile updated successfully.', 'success');
            } else {
                uiStore.showNotification('Failed to update profile.', 'error');
            }
            uiStore.setLoading(false);
        }

    };
    const handlePasswordChange = async (e) => {
        let user = User;
        if (e.currentTarget.id === 'Password') {
            setPassword(e.target.value)
        }
        if (e.currentTarget.id === 'ConfirmPassword') {
            setConfirmPassword(e.target.value);
        }
        setUser(user);
        forceUpdate();
    };
    const handleUpdatePasswordClicked = async () => {
        uiStore.setLoading(true);
        try {
            let regexPass = validatePassword(Password);
            if (regexPass === '' || undefined) {
                uiStore.setLoading(false);
                return;
            }

            if (regexPass !== ConfirmPassword) {
                uiStore.showNotification('Passwords do not match', 'error');
                uiStore.setLoading(false);
                return;
            }
            let updatePassword = await userStore.updatePassword(authStore.user.email, regexPass);
            if (!updatePassword || updatePassword === 'error') {
                uiStore.showNotification('Error updating password', 'error');
                uiStore.setLoading(false);
                return;
            }
            uiStore.showNotification('Password updated successfully.', 'success');
            setIsEditDetails(false);
            setIsEditPassword(false);
            uiStore.setLoading(false);
            forceUpdate();
        } catch (error) {
            uiStore.showNotification('An error occurred while updating the password. Please try again later.', 'error');
            uiStore.setLoading(false);
            return
        }
    };
    function validatePassword(password) {
        if (!password) {
            uiStore.showNotification('Password is required.', 'error');
            return '';
        };
        if (!/(?=.*[a-z])/.test(password)) {
            uiStore.showNotification('Password must contain at least one lowercase letter.', 'error');
            return '';
        };
        if (!/(?=.*[A-Z])/.test(password)) {
            uiStore.showNotification('Password must contain at least one uppercase letter.', 'error');
            return '';
        };
        if (!/(?=.*[0-9])/.test(password)) {
            uiStore.showNotification('Password must contain at least one digit.', 'error');
            return '';
        };
        if (!/(?=.*[!@#\$%\^&\*])/.test(password)) {
            uiStore.showNotification('Password must contain at least one special character (!@#$%^&*).', 'error');
            return;
        };
        if (!/(?=.{8,})/.test(password)) {
            uiStore.showNotification('Password must be at least 8 characters long.', 'error');
            return '';
        };
        return password;
    };
    const fileInputRef = useRef(null);
    const handleAddDevice = async () => {
        uiStore.setLoading(true);
        try {
            let addWebauthn = await authStore.addWebauthn();
            if (addWebauthn) {
                uiStore.showNotification('Device added successfully.', 'success');
            } else {
                uiStore.showNotification('Failed to add device. Please try again.', 'error');
            }
            uiStore.setLoading(false);
        } catch (e) {
            uiStore.showNotification('Failed to add device. Please try again.', 'error');
            uiStore.setLoading(false);
        }

    };
    const handleDeleteBiomet = async (e) => {
        uiStore.setLoading(true);
        let userEmail = authStore.user.email;
        try {
            let user = User;
            let auths = user.Authenticators;
            if (e >= 0 && e < auths.length) {
                auths.splice(e, 1);
            }
            let updateUser = await userStore.updateUserByEmail(user, userEmail);
            if (!updateUser) {
                uiStore.showNotification('Failed to delete authenticator.', 'error');
                uiStore.setLoading(false);
                return
            };
            uiStore.showNotification('Authenticator deleted successfully.', 'success');
            uiStore.setLoading(false);
            forceUpdate();
        } catch (error) {
            uiStore.showNotification('An error occurred while deleting the authenticator.', 'error');
            uiStore.setLoading(false);
            return
        }
    };
    if (mobile()) {
        return (
            <div>
            </div>
        );
    } else {
        return (
            <div className='user-profile-Container'>
                <div className='profile-top-section'>
                    <p>Profile</p>
                    <img src={Credipple} alt='' />
                </div>
                <div className='profile-body'>
                    <div className='user-details'>
                        <div className='details-header'>
                            <p>Details</p>
                        </div>
                        <div className="user-profile" style={{ backgroundColor: '#eaeaea' }}>
                            <img style={{ width: '100%', height: '100%' }} src={UserIcon} alt=''/>
                        </div>
                        <input type="file" ref={fileInputRef} style={{ display: 'none' }} accept="image/*" />
                        {(IsEditDetails) ?
                            <div className='update-user-Details'>
                                <TextInput className='userDetails-inputs' label='Name & Surname' value={FullName} id='FullName' onChange={handleUserInfoChange} />
                                <TextInput className='userDetails-inputs' label='Email' value={User.email} id='Email' onChange={handleUserInfoChange} />
                                <TextInput className='userDetails-inputs' label='Contact Number' value={User.phone} id='Phone' onChange={handleUserInfoChange} />
                                <OutlinedButton className='btn-Cancel' onClick={handleEditPasswordClose}>Cancel</OutlinedButton>
                                <OutlinedButton className='btn-Save' onClick={handleUpdateUserClicked}>Save</OutlinedButton>
                            </div> :
                            <div className='user-detail-container' >
                                <p className='placeHolder'>Name & Surname</p>
                                <p className='value'>{User.firstName || ''} {User.lastName || ''}</p>
                                <p className='placeHolder'>Email</p>
                                <p className='value'>{User.email || ''}</p>
                                <p className='placeHolder'>Contact Number</p>
                                <p className='value'>{User.phone || ''}</p>
                            </div>}
                    </div>
                    <div className='user-password'>
                        {(IsEditPassword) ?
                            <div className='updatepassword-sect'>
                                <div className='updateSecurity-header'>
                                    <p className='title'>Security</p>
                                </div>
                                <div className='passwordFields-section'>
                                    <TextInput className='text-input' label='New Password' type='password' id='Password' onChange={handlePasswordChange} />
                                    <TextInput className='text-input' label='Confirm Password' type='password' id='ConfirmPassword' onChange={handlePasswordChange} />
                                </div>
                                <div className='security-action-Container'>
                                    <OutlinedButton className='btn-Cancel' onClick={handleEditPasswordClose}>Cancel</OutlinedButton>
                                    <OutlinedButton className='btn-Save' onClick={handleUpdatePasswordClicked}>Save</OutlinedButton>
                                </div>
                            </div> :
                            <div className='security-Password'>
                                <div className='security-header'>
                                    <p className='title'>Security</p>
                                    <img style={{ cursor: 'pointer' }} onClick={handleEditPassword} src={EditIcon} alt='' />
                                </div>
                                <div className='security-body'>
                                    <p className='placeHolder' style={{ margin: ' 0 0 1% 0 ' }}>Password</p>
                                    <p className='value' style={{ margin: '0px', color: '#AFAFAF' }}>**********</p>
                                </div>
                            </div>}
                        <div className='user-device-biometrics'>
                            <div className='AddDevice-biometrics'>
                                <p>Device Biometrics</p>
                                <div style={{ cursor: 'pointer' }}>
                                    <img src={AddIcon} alt='' onClick={handleAddDevice} />
                                    <p onClick={handleAddDevice}>Add</p>
                                </div>
                            </div>
                            <div className='avail-device-biometrics'>
                                <div className='label-section'>
                                    <p style={{ width: '45%' }}>Device Key</p>
                                </div>
                                <div className='Devices-container'>
                                    {User.Authenticators && User.Authenticators.length > 0 ? (
                                        User.Authenticators.map((item, index) => {
                                            let key = item.authrInfo.publicKey;
                                            let displayKey = `${key.slice(0, 12)}...`;
                                            return (
                                                <div className='device-section' key={index}>
                                                    <p style={{ width: '95%' }}>{displayKey || ''}</p>
                                                    <img style={{ cursor: 'pointer' }} src={DeleteIcon} alt='Delete Icon' onClick={() => handleDeleteBiomet(index)} />
                                                </div>
                                            )
                                        })
                                    ) : (
                                        <div className='device-section'>
                                            <p style={{ width: '95%' }}>No Authenticators</p>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
})

export default Profile;